import { ShieldCheck } from 'lucide-react';

import type { SessionStepDto } from '../schemas/sessionSchemas';

export function ComingSoonStep({ step }: { step: SessionStepDto }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[#F3F4F6]">
        <ShieldCheck size={28} className="text-[#9CA3AF]" />
      </div>
      <h3 className="mb-2 text-base font-semibold text-[#041A3A]">{step.displayName}</h3>
      <p className="text-sm leading-snug text-[#666666]">
        Live verification for this step is coming soon.
      </p>
    </div>
  );
}
